import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Spinner from '../../Components/Progress/Spinner'

function ProfileLinks() {
  const navigate = useNavigate()
  const { type } = useParams()

  const redirect = (path = '/dashboard/profile', state) => {
    if (state) {
      navigate(path, state)
    } else {
      navigate(path)
    }
  }

  const cta = () => {
    switch (type) {
      case 'edit':
        redirect()
        break
      default:
        redirect('/dashboard')
        break
    }
  }

  useEffect(() => {
    if (!type) redirect()
    else cta()
  }, [])

  return <Spinner />
}

export default ProfileLinks
